
import { HttpProvider } from "../http/http.provider";

import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { IHttpRequestConfig } from "../http";
import { BenchEmployeeDelegate } from "../BenchEmployeeService/bench-employee.delegate";
import { ProjectDelegate } from "../ProjectService/project.delegate";
import
    {
        ISalesRep,
        INewSalesRep,
        ISalesRepResponse,
        ISalesRepDetailResponse,
        ISalesRepBenchSubmission,
        ISalesStatResponse
    } from "./salesrep.interface";

/**
 * 
 */

export class SalesRepDelegate
{

    constructor(private http: HttpProvider)
    {
    }

    public getSalesRepBySalesRepId(salesRepId: string): Observable<ISalesRepDetailResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                salesRepId: salesRepId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.SALESREP.GET_BY_ID, null, config).pipe(
            map((response: any) =>
            {
                return {
                    salesRep: this.normalizeSalesRep(response.data.salesRep),
                    success: response.data.success
                };
            }),
            share());
    }

    public getProcessSubmissionReport(orgId: string,
        userId: string,
        fromDate: Date | string,
        toDate: Date | string, sendEmail: boolean): Observable<ISalesStatResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                orgId: orgId,
                userId: userId,
                fromDate: fromDate,
                toDate: toDate,
                sendEmail: sendEmail
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.SALESREP.PROCESS_SUBMISSION_REPORT, null, config).pipe(
            map((response: any) =>
            {
                return {
                    success: response.data.success,
                    salesRepBenchSubmissionStats: response.data.salesStats.salesRepBenchSubmissionStats,
                    salesReps: response.data.salesStats.salesReps.filter(x => x.benchSubmissionCount > 0)
                };
            }),
            share());
    }




    public getProcessInterviewReport(orgId: string,
        userId: string,
        fromDate: Date | string,
        toDate: Date | string, sendEmail: boolean): Observable<ISalesStatResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                orgId: orgId,
                userId: userId,
                fromDate: fromDate,
                toDate: toDate,
                sendEmail: sendEmail
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.SALESREP.PROCESS_INTERVIEW_REPORT, null, config).pipe(
            map((response: any) =>
            {
                return {
                    success: response.data.success,
                    salesRepBenchInterviewStats: response.data.salesBenchInterviewStats.salesRepBenchInterviewStats,
                    benchInterviews: response.data.salesBenchInterviewStats.benchInterviews
                };
            }),
            share());
    }

    public getSalesRepDailySubmissionsBySalesRepId(salesRepId: string, fromDate: Date | string,
        toDate: Date | string, benchStatus: string): Observable<ISalesRepResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                salesRepId: salesRepId,
                fromDate: fromDate,
                toDate: toDate,
                benchStatus: benchStatus

            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.SALESREP.GET_DAILY_SUBMISSION_BY_ID, null, config).pipe(
            map((response: any) =>
            {
                return {
                    salesRepSubmission: this.normalizeSalesRepDailySubmission(response.data.benchEmployeeSubmissionData),
                    success: response.data.success,
                    salesRepId: salesRepId
                };
            }),
            share());
    }


    public getAllSalesRepsByOrgId(orgId: string, activeLeads: boolean): Observable<ISalesRepResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                orgId: orgId,
                activeData: activeLeads

            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.SALESREP.GET, null, config).pipe(
            map((response: any) =>
            {

                return {
                    salesReps: this.normalizeSalesReps(response.data.salesReps),
                    success: response.data.success
                };
            }),
            share());
    }

    public getAllLeadRepsByOrgId(orgId: string, activeLeads: boolean): Observable<ISalesRepResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                orgId: orgId,
                activeData: activeLeads
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.LEADREP.GET, null, config).pipe(
            map((response: any) =>
            {

                return {
                    salesReps: this.normalizeSalesReps(response.data.salesReps),
                    success: response.data.success
                };
            }),
            share());
    }
    public createNewSalesRep(newSalesRep: INewSalesRep): Observable<ISalesRepResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.SALESREP.CREATE, newSalesRep).pipe(
            map((response: any) =>
            {
                return {
                    salesReps: this.normalizeSalesReps(response.data.salesReps),
                    success: response.data.success,
                    salesRepId: response.data.salesRepId
                };
            }),
            share());
    }

    public createNewLeadRep(newSalesRep: INewSalesRep): Observable<ISalesRepResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.LEADREP.CREATE, newSalesRep).pipe(
            map((response: any) =>
            {
                return {
                    salesReps: this.normalizeSalesReps(response.data.salesReps),
                    success: response.data.success,
                    salesRepId: response.data.salesRepId
                };
            }),
            share());
    }

    public updateLeadRep(salesRep: ISalesRep): Observable<ISalesRepResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.LEADREP.UPDATE, salesRep).pipe(
            map((response: any) =>
            {
                return {
                    salesReps: this.normalizeSalesReps(response.data.salesReps),
                    success: response.data.success,
                    salesRepId: salesRep.salesRepId
                };
            }),
            share());
    }

    public updateSalesRep(salesRep: ISalesRep): Observable<ISalesRepResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.SALESREP.UPDATE, salesRep).pipe(
            map((response: any) =>
            {
                return {
                    salesReps: this.normalizeSalesReps(response.data.salesReps),
                    success: response.data.success,
                    salesRepId: salesRep.salesRepId
                };
            }),
            share());
    }

    private normalizeSalesReps(salesReps: any): ISalesRep[]
    {
        return salesReps.map(salesRep =>
        {
            //salesRep.projectCode = ProjectDelegate.normalizeProjectCodes(salesRep.projectCode);
            // salesRep.benchEmployee = BenchEmployeeDelegate.normalizeBenchEmployees(salesRep.benchEmployee);
            salesRep.createSalesRepLogin = !!salesRep.userId;

            return salesRep;
        });
    }

    private normalizeSalesRepDailySubmission(salesRepSubmission: any): ISalesRepBenchSubmission[]
    {
        return salesRepSubmission.map(submission =>
        {
            submission.benchEmployeeName = submission.benchEmployee.fullName;


            return submission;
        });


    }

    private normalizeSalesRep(salesRep: any): ISalesRep
    {
        salesRep.projectCode = ProjectDelegate.normalizeProjectCodes(salesRep.projectCodes);
        salesRep.benchEmployee = BenchEmployeeDelegate.normalizeBenchEmployees(salesRep.benchEmployeeSalesReps ? salesRep.benchEmployeeSalesReps : []);
        salesRep.createSalesRepLogin = !!salesRep.userId;
        return salesRep;

    }
}